import React from 'react';
import { ActionButton } from '@fluentui/react';

function Complete({ steps, score, back, data }) {
    // Check if any step has at least one correct answer
    const hasCorrectAnswers = steps?.some(step =>
        Array.isArray(step.answers) &&
        step.answers.some(ans => ans.isCorrect === true)
    );

    debugger;

    return (
        <div className="flexcolumn displayflex flex1 aligncenter prelative pt20 mb50">
            {back && (
                <ActionButton
                    iconProps={{ iconName: 'ChromeBack' }}
                    style={{ top: -15, left: 0 }}
                    onClick={back}
                    className="c-back-button"
                >
                    List
                </ActionButton>
            )}

            <h3 className="head-30 mb10 mt10">Good Job, Chris!</h3>
            <p className="mb20">
                You've successfully completed the {data.courseTypeId === 1 ? 'quiz' : 'lesson'}.
            </p>
            <img style={{ width: 150 }} src="https://teamsly-cdn-cuc0cvgwakbtarf9.z01.azurefd.net/images/trophy.png" alt="Trophy" />

            {hasCorrectAnswers && (
                <>
                    <h3 className="head-30 mt20" style={{ fontSize: 42, color: '#4cbaa5' }}>
                        {score}%
                    </h3>
                    <p className="mb20 mt15">Your Score</p>
                </>
            )}

            {data.completionDescription && (
                <div
                    className="p20 mt20 "
                    style={{ borderRadius: 5, backgroundColor: 'rgba(var(--palette-neutral-4), 1)' }}
                >
                    <div>{data.completionDescription}</div>
                </div>
            )}
        </div>
    );
}

export default Complete;